import store from 'source/store';

function checkUserAccess(to, from, next) {
    const employment = store.state.auth.user?.user_profile?.employment_id;

    if (to.name !== 'initial-onboarding' || !employment) {
        next({ name: 'access-denied' });
    }
    next();
}

export default [{
    path: 'getting-started',
    component: () => import ('source/pages/root/InitialOnboardingPageGroup.vue'),
    meta: {
        title: 'Getting Started - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: '',
            name: 'initial-onboarding',
            component: () => import('source/pages/board/onboarding/InitialOnboardingPage.vue'),
            beforeEnter: checkUserAccess,
            meta: {
                title: 'Getting Started - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        }
    ]
}];
